import type { ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { RuntimeEffects } from '@/app/providers/RuntimeEffects';
import { LandingIntlProvider } from './i18n';

interface LandingPageProvidersProps {
  children: ReactNode;
}

export function LandingPageProviders({ children }: LandingPageProvidersProps) {
  return (
    <HelmetProvider>
      <LandingIntlProvider>
        <RuntimeEffects />
        {children}
      </LandingIntlProvider>
    </HelmetProvider>
  );
}
